import { find, isEmpty } from 'lodash';
import quoteTypes from 'commons-vehicle/Quote/actions/quoteActionTypes.js';

export function setQuote(quote) {
    return { type: quoteTypes.SET_QUOTE, quote };
}

export function setQuoteV25(quote) {
    return { type: quoteTypes.SET_QUOTEV25, quote };
}

export function setQuoteModified() {
    return { type: quoteTypes.SET_QUOTE_MODIFIED };
}

export function setQuoteRevision(quoteRevisions) {
    return (dispatch, getState) => {
        const state = getState();
        if (state.quote && state.quote.id && !isEmpty(quoteRevisions)) {
            const currentQuoteRevision = find(quoteRevisions, (quoteRevision) => {
                return quoteRevision.id === state.quote.id;
            });

            if (currentQuoteRevision) {
                // eslint-disable no-underscore-dangle
                const revision = currentQuoteRevision.__revision;
                dispatch({ type: quoteTypes.SET_QUOTE_REVISION, revision });
            }
        }
    };
}

export function setQuoteVehicle(vehicle) {
    return { type: quoteTypes.SET_QUOTE_VEHICLE, vehicle };
}

export function setQuoteModelYear(modelYear) {
    return { type: quoteTypes.SET_QUOTE_MODEL_YEAR, modelYear };
}

export function setQuoteLeadType(leadType) {
    return { type: quoteTypes.SET_LEAD_TYPE, leadType };
}

export function setQuoteStatus(status) {
    return { type: quoteTypes.SET_STATUS, status };
}

export function setQuoteSecurityToken(securityToken) {
    return { type: quoteTypes.SET_SECURITY_TOKEN, securityToken };
}

export function setQuotePurchaseMethods(purchaseMethods) {
    return { type: quoteTypes.SET_QUOTE_PURCHASE_METHODS, purchaseMethods };
}

export function setQuoteLoading(loading) {
    return { type: quoteTypes.SET_LOADING, loading };
}

export function setQuoteError(error) {
    return { type: quoteTypes.SET_ERROR, error };
}

export default {
    setQuote,
    setQuoteV25,
    setQuoteModified,
    setQuoteRevision,
    setQuoteVehicle,
    setQuoteModelYear,
    setQuoteLeadType,
    setQuoteStatus,
    setQuoteSecurityToken,
    setQuotePurchaseMethods,
    setQuoteLoading,
    setQuoteError,
};
